import { Injectable } from '@angular/core';
import * as CookieConsent from 'vanilla-cookieconsent';
import { TranslocoService } from '@ngneat/transloco';
import { take } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {


  private initialized = false;



  constructor(
    private translocoService: TranslocoService
  ) { }



  init(): void {


    if (this.initialized) {
      return;
    }


    this.initializeCookieConsent();

  }



  private initializeCookieConsent(): void {


    CookieConsent.run({


      guiOptions: {

        consentModal: {

          layout: 'box',
          position: 'bottom right',
          equalWeightButtons: true,
          flipButtons: false

        },


        preferencesModal: {

          layout: 'box',
          equalWeightButtons: true,
          flipButtons: false

        }

      },



      categories: {


        necessary: {

          enabled: true,
          readOnly: true

        },


        analytics: {


          autoClear: {

            cookies: [

              {
                name: /^_ga/
              },

              {
                name: '_gid'
              }

            ]

          }

        }

      },



      language: {


        default: this.translocoService.getActiveLang(),


        translations: this.buildTranslations()

      },



      onFirstConsent: () => {

        this.handleConsent();

      },


      onConsent: () => {

        this.handleConsent();

      },


      onChange: () => {

        this.handleConsent();

      }


    });



    this.initialized = true;

  }




  private buildTranslations(): any {


    const t = (key: string) =>
      this.translocoService.translate(key);



    const lang =
      this.translocoService.getActiveLang();



    return {


      [lang]: {



        consentModal: {


          title: t('cookies.consent.title'),


          description: t('cookies.consent.description'),


          acceptAllBtn: t('cookies.consent.acceptAll'),


          acceptNecessaryBtn: t('cookies.consent.onlyNecessary'),


          showPreferencesBtn: t('cookies.consent.preferences')


        },



        preferencesModal: {



          title: t('cookies.preferences.title'),


          acceptAllBtn: t('cookies.consent.acceptAll'),


          acceptNecessaryBtn: t('cookies.consent.rejectOptional'),


          savePreferencesBtn: t('cookies.consent.save'),


          closeIconLabel: t('cookies.consent.close'),



          sections: [



            {

              title: t('cookies.sections.usage.title'),

              description: t('cookies.sections.usage.description')

            },



            {

              title: t('cookies.sections.necessary.title'),

              description: t('cookies.sections.necessary.description'),

              linkedCategory: 'necessary'

            },



            {

              title: t('cookies.sections.analytics.title'),

              description: t('cookies.sections.analytics.description'),

              linkedCategory: 'analytics'

            }


          ]


        }


      }


    };


  }




  changeLanguage(lang: string): void {



    this.translocoService.load(lang)
      .pipe(take(1))
      .subscribe(() => {



        this.translocoService.setActiveLang(lang);



        localStorage.setItem(
          'lang',
          lang
        );



        if (this.initialized) {


          CookieConsent.setLanguage(lang);
          //check for right reset
          CookieConsent.reset();

        }



      });


  }





  private handleConsent(): void {



    const analyticsAccepted =
      CookieConsent.acceptedCategory('analytics');



    if (analyticsAccepted) {


      console.log(
        'Analytics consentito'
      );


      // inizializza GA/GTM/Matomo



    } else {


      console.log(
        'Analytics NON consentito'
      );


    }


  }




  showPreferences(): void {


    CookieConsent.showPreferences();


  }





  reset(): void {


    CookieConsent.reset(true);


  }


}